import Vue from "vue";
import CommonApi from "./api/common.api";

export const state = Vue.observable({
    siteInfo: window.regionTorg?.preload?.header ?? {},
});

export const mutations = {
    setSiteInfo: val => {
        state.siteInfo = val;
    },
};

export const actions = {
    async fetchSiteInfo() {
        const siteInfo = await CommonApi.getSiteInfo();
        mutations.setSiteInfo(siteInfo);
    },
};
